import React from 'react'
import ReactDOM from 'react-dom'

import App from './App'
import { StripeSecretProvider } from './context/StripeSecret'
import { ToastProvider } from './context/Toast'
import { PlansProvider } from './context/Plans'
import { SelectedPlanProvider } from './context/SelectedPlan'
import { PurchasedPlanProvider } from './context/PurchasedPlan'

ReactDOM.render(
    <React.StrictMode>
        <StripeSecretProvider>
            <PlansProvider>
                <SelectedPlanProvider>
                    <PurchasedPlanProvider>
                        <ToastProvider>
                            <App />
                        </ToastProvider>
                    </PurchasedPlanProvider>
                </SelectedPlanProvider>
            </PlansProvider>
        </StripeSecretProvider>
    </React.StrictMode>,
    document.getElementById('root')
)
